
import './App.css';


 import Navroutes from './Mainroutes/Navroutes';

function App() {
  return (
    <div className="App">
     <Navroutes/>
      
    </div>
  );
}

export default App;
